var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"justify-center"},[_c('v-col',{attrs:{"cols":"8"}},[_c('v-img',{attrs:{"width":"800","height":"800","src":require("@/assets/sigefLogin.png")}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }